angular.module('gym.membership-plans').controller('CopyBookAndPayUrlModalCtrl', ["$scope", "$modalInstance", "$timeout", "plan", function($scope, $modalInstance, $timeout, plan) {
  $scope.membershipPlan = plan;
  $scope.getUnavailableError = function(membershipPlan) {
    var ref;
    if ((ref = membershipPlan.default_start_date_strategy) === 'start_on_next_upcoming' || ref === 'start_relative_to_purchase_date') {
      return 'plan is set to start in the future';
    }
    if (membershipPlan.specified_start_date) {
      return 'plan is set to start on a specific date';
    }
    if (!membershipPlan.restrict_access_by_event_type) {
      return 'no Event Type limit present';
    }
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.getLink = function(membershipPlan) {
    return `${window.location.host}${membershipPlan.book_and_pay_url}`;
  };
  $scope.paymentOnlyLink = function(membershipPlan) {
    return `${window.location.host}${membershipPlan.book_and_pay_payment_only_url}`;
  };
  $scope.onCopied = function() {
    $scope.copied = true;
    return $timeout(function() {
      return $scope.copied = false;
    }, 1500);
  };
  return $scope.onPaymentOnlyCopied = function() {
    $scope.paymentOnlyCopied = true;
    return $timeout(function() {
      return $scope.paymentOnlyCopied = false;
    }, 1500);
  };
}]);
